module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('Grid', {
		configure: function(options) {
			this.registerOptions('', {
				autoRender: true
			});
			this.callParent('configure', arguments);
		},

		getDataLayer: function() {
			return this.dl;
		},

		initDl: function() {
			this.embedWidgetsFromOptions();

			var w = this.wom1('#dl');
			if (w) {
				w.run();
				this.dl = w;
				return;
			}
			
			var dl = this.getOption('dataLayer') || this.getOption('dl');

			if (dl && (dl._objClass == 'DataLayer' || dl._widgetClass == 'Datalayer')) {
				this.dl = dl;
			} else if (dl && fox.isString(dl)) {
				this.dl = fox.wom.selectFirst(dl, this);
			} else if (this.getOption('dlMethod')) {
				this.dl = fox.createDataLayer().setMethod(this.getOption('dlMethod'));
				this.dl.set(dl || {});
			}

			if (this.dl && this.dl.run) {
				this.dl.run();
			}
		},

		initChild: function(alias, options) {
			if (!options.widget) {
				options.widget = 'Grid_' + fox.ucfirst(alias);
				if (options.plugin) {
					options.widget = options.widget + '_' + fox.ucfirst(options.plugin);
				}
			}
			
			if (alias == 'list' && !this.getOption('template')) {
				fox.objectSet(options, ['embed.widget'], '@parent ' + this.getOption('embed.widget'));
				fox.objectSet(options, ['embed.container'], this.getOption('embed.container') || this.getOption('container'));
				this.visual = false;
			}
			this.embedWidget(alias, options.widget, options);

		},

		preparing: function() {
			this.callParent('preparing', arguments);
			this.initDl();
		},

		init: function() {
			this.callParent('init', arguments);

			if (this.dl.run) {
				this.dl.run();
			}

			this.registerOptions('.Controller', {dl: this.dl, dataLayer: this.dl});
			//rpp check
			fox.each(['list', 'pager', 'rpp'], function(alias) {
				if (this.getOption(alias)) {
					this.initChild(alias, this.getOption(alias) || {});
				}
			}, this);

			this.forwardEvent(this.dl, 'startWorking');
			this.forwardEvent(this.dl, 'stopWorking');


			this.handleEvent(this.dl, 'loaded', fox.bind(function() {
				this.dispatchEvent('updated');
			}, this), {prefix: 'gridUpdated'});
		},

		running: function() {
			if (!this.getOption('externalLoad')) {
				this.dl.load();
			}
		}
	});
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/grid/grid.js
// module id = 200
// module chunks = 0